import React from "react";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import Validator from "../../../../helpers/validator";
import {errorMessages} from "../../../../helpers/errorMessage";
import {RouteComponentProps} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import {withRouter} from "react-router";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {ShipownerService} from "../../../services/shipownerService";
import DropDown from "../../../../common/components/shared/dropDown/dropDown";
import {CountryModel} from "../../../../common/models/country";
import {CountryService} from "../../../../common/services/countryService";
import {ShipownerModel} from "../../../models/shipowners";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import "./shipownerForm.scss";
import Form from "../../../../common/components/shared/form/form";
import {Utils} from "../../../../helpers/utils";
import {DropDownUtils} from "../../../../helpers/dropDownUtils";
import Loader from "../../../../common/components/shared/loader/loader";

interface ShipownerFormState {
    countries: CountryModel[];
    isSubmitButtonBlocked: boolean;
    displayErrorMessage: boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    countriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface ShipownerFormProps extends RouteComponentProps {
    shipownerData?: ShipownerModel | null;
    isUpdate: boolean;
}

class ShipownerForm extends React.Component <ShipownerFormProps, ShipownerFormState> {
    private taxNo!: ValidatedValue<string>;
    private imoCode!: ValidatedValue<string>;
    private name!: ValidatedValue<string>;
    private street!: ValidatedValue<string>;
    private postalCode!: ValidatedValue<string>;
    private city!: ValidatedValue<string>;
    private countryImoCode!: ValidatedValue<string>;
    private phoneNo!: ValidatedValue<string>;

    constructor(props: any) {
        super(props);

        const shipownerValidators = [{
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: errorMessages.required
        }];

        this.taxNo = new ValidatedValue("", shipownerValidators);
        this.imoCode = new ValidatedValue("", shipownerValidators);
        this.name = new ValidatedValue("", shipownerValidators);
        this.street = new ValidatedValue("", shipownerValidators);
        this.postalCode = new ValidatedValue("", shipownerValidators);
        this.city = new ValidatedValue("", shipownerValidators);
        this.countryImoCode = new ValidatedValue("", shipownerValidators);
        this.phoneNo = new ValidatedValue("", shipownerValidators);

        this.state = {
            countries: [],
            isSubmitButtonBlocked: false,
            displayErrorMessage: false,
            response: undefined,
            countriesResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getData();
    }

    private async getData() {
        const countriesResponse = await CountryService.getAll();

        this.setState({
            countries: (countriesResponse)?.data?.data || [],
            countriesResponse
        });

        if (this.props.isUpdate) {
            this.setShipownerData();
        }
    }

    render() {
        if (this.state.countries.length > 0 || !Api.isSuccess(this.state.countriesResponse)) {
            return (
                <Form
                    class="shipowner-form"
                    renderError={this.renderErrors()}
                    renderContent={this.renderContent()}
                    isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                    backAddress={routingAddresses.dictionaries.shipowners.list}
                    submit={this.submit.bind(this)}
                />
            );
        } else {
            return <Loader/>;
        }
    }

    renderErrors() {
        if(!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={this.getErrorMessage()}
                    translatedFields={{
                        taxNo: i18n.t("dictionaries.shipowners.httpErrors.taxNo"),
                        name: i18n.t("dictionaries.shipowners.httpErrors.name")
                    }}
                    translatedFieldsForEmpty={{
                        taxNo: i18n.t("dictionaries.shipowners.httpErrors.taxNoForEmpty"),
                        imoCode: i18n.t("dictionaries.shipowners.httpErrors.imoCodeForEmpty"),
                        name: i18n.t("dictionaries.shipowners.httpErrors.nameForEmpty"),
                        street: i18n.t("dictionaries.shipowners.httpErrors.streetForEmpty"),
                        postalCode: i18n.t("dictionaries.shipowners.httpErrors.postalCodeForEmpty"),
                        city: i18n.t("dictionaries.shipowners.httpErrors.cityForEmpty"),
                        country: i18n.t("dictionaries.shipowners.httpErrors.countryForEmpty"),
                        phoneNo: i18n.t("dictionaries.shipowners.httpErrors.phoneNoForEmpty")
                    }}
                    object={i18n.t("dictionaries.shipowners.httpErrors.object")}
                />
            );
        }
    }

    renderContent() {
        return (
            <>
                <TextInput label={i18n.t("dictionaries.shipowners.headers.taxNo")} validatedValue={this.taxNo} testId="shipowner-tax-no"/>
                <TextInput label={i18n.t("dictionaries.shipowners.headers.imoCode")} validatedValue={this.imoCode} testId="shipowner-imo-code"/>
                <div className="address-section">
                    <TextInput label={i18n.t("dictionaries.shipowners.headers.name")} validatedValue={this.name} testId="shipowner-name"/>
                    <TextInput label={i18n.t("dictionaries.shipowners.headers.street")} validatedValue={this.street} testId="shipowner-street"/>
                    <TextInput label={i18n.t("dictionaries.shipowners.headers.postalCode")} validatedValue={this.postalCode} testId="shipowner-postal-code"/>
                    <TextInput label={i18n.t("dictionaries.shipowners.headers.city")} validatedValue={this.city} testId="shipowner-city"/>
                    <DropDown
                        label={i18n.t("dictionaries.shipowners.headers.countryName")}
                        validatedValue={this.countryImoCode}
                        items={this.countriesToDropDownMap}
                        testId="shipowner-country"
                        error={!Api.isSuccess(this.state.countriesResponse) ? i18n.t("errorMessages.countriesErrorSuffix") : ""}
                        reloadFunc={() => this.getData()}
                    />
                    <TextInput label={i18n.t("dictionaries.shipowners.headers.phoneNo")} validatedValue={this.phoneNo} testId="shipowner-phone-no"/>
                </div>
            </>
        );
    }

    private getErrorMessage() {
        return this.props.isUpdate
            ? i18n.t("dictionaries.shipowners.errors.modifyErrorSuffix")
            : i18n.t("dictionaries.shipowners.errors.addErrorSuffix");
    }

    public get countriesToDropDownMap() {
        return DropDownUtils.listToDropDownMap(this.state.countries, "imoCode");
    }

    public get isValid() {
        this.taxNo!.validate();
        this.imoCode!.validate();
        this.name!.validate();
        this.street!.validate();
        this.postalCode!.validate();
        this.city!.validate();
        this.countryImoCode!.validate();
        this.phoneNo!.validate();

        return this.taxNo.isValid
            && this.imoCode.isValid
            && this.name.isValid
            && this.street.isValid
            && this.postalCode.isValid
            && this.city.isValid
            && this.countryImoCode.isValid
            && this.phoneNo.isValid;
    }

    private setShipownerData() {
        this.taxNo.setValue(this.props.shipownerData?.taxNo || "");
        this.imoCode.setValue(this.props.shipownerData?.imoCode || "");
        this.name.setValue(this.props.shipownerData?.name || "");
        this.street.setValue(this.props.shipownerData?.street || "");
        this.postalCode.setValue(this.props.shipownerData?.postalCode || "");
        this.city.setValue(this.props.shipownerData?.city || "");
        const countryName = this.props.shipownerData?.countryName;
        this.countryImoCode.setValue(this.state.countries.find((x) => x.name === countryName)?.imoCode || "");
        this.phoneNo.setValue(this.props.shipownerData?.phoneNo || "");
    }

    private async submit() {
        this.setState({response: undefined});

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});
            await this.addOrModifyShipowner();
            this.setState({isSubmitButtonBlocked: false});

            if (Api.isSuccess(this.state.response)) {
                this.props.history.push(routingAddresses.dictionaries.shipowners.list);
            }
        }
        Utils.scrollToFirstErrorMessage();
    }

    private async addOrModifyShipowner(){
        if (this.props.isUpdate && this.props.shipownerData?.id) {
            this.setState({
                response: await ShipownerService.modifyShipowner({
                    taxNo: this.taxNo.value.trim(),
                    imoCode: this.imoCode.value.trim(),
                    name: this.name.value.trim(),
                    street: this.street.value.trim(),
                    postalCode: this.postalCode.value.trim(),
                    city: this.city.value.trim(),
                    countryImoCode: this.countryImoCode.value,
                    phoneNo: this.phoneNo.value.trim()
                }, this.props.shipownerData?.id)
            });
        } else {
            this.setState({
                response: await ShipownerService.addShipowner({
                    taxNo: this.taxNo.value.trim(),
                    imoCode: this.imoCode.value.trim(),
                    name: this.name.value.trim(),
                    street: this.street.value.trim(),
                    postalCode: this.postalCode.value.trim(),
                    city: this.city.value.trim(),
                    countryImoCode: this.countryImoCode.value,
                    phoneNo: this.phoneNo.value.trim()
                })
            });
        }
    }
}

export default withRouter(ShipownerForm);
